namespace $ {
	/** Lazy prefix, like the code editor, in physical viewport coordinates.
	 * Retaining measured rows avoids scroll jumps from estimated Markdown heights.
	 */
	export function $shm_hitalama_text_window( list: $mol_list, next?: [ number, number ] ): [ number, number ] {
		const rows = list.sub()
		if( rows.length < 3 || list.$.$mol_print.active() ) return [ 0, rows.length ]
		const rect = list.view_rect()
		if( next ) return next
		const previous = $mol_mem_cached( ()=> list.view_window() ) ?? [ 0, 0 ]
		const shift = list.view_window_shift()
		list.view_window_shift( 0 )
		let end = Math.max( 0, Math.min( rows.length, previous[1] + shift ) )
		// A retained document can be connected again before its cached geometry
		// catches up with attachment. Subtracting the old tail from a zero rect
		// expands the prefix to the whole document. Keep it until view_rect updates.
		if( !rect || rect.width <= 0 ) return [ 0, end ]
		const width = ( list.dom_node() as HTMLElement ).offsetWidth
		if( !width ) return [ 0, end ]
		const scale = rect.width / width
		const gap = $mol_mem_cached( ()=> list.gap_after() ) ?? 0
		let bottom = ( rect?.bottom ?? 0 ) - gap * scale
		const viewport = list.$.$mol_window.size().height + 40
		const limit = viewport * ( 1 + list.render_over() )
		while( end < rows.length && bottom < limit ) bottom += list.item_height_min( end++ ) * scale
		return [ 0, end ]
	}
}
